<p-dialog
		[(visible)]="visibleLocal"
		[modal]="true"
		(onHide)="fermerModal()"
		[draggable]="true"
		[resizable]="false">
	<p-header>
		<span>{{ 'ACCUEIL.TITRE_POPUP_CONFLIT_BUREAU_PREFERENTIEL' | translate }}</span>
	</p-header>
	<p>
		{{ 'ACCUEIL.CONTENU_POPUP_CONFLIT_BUREAU_PREFERENTIEL' | translate:{date: dateConflitFormatee()} }}
	</p>
	<p-footer>
		<p-button
				[label]="'GLOBAL.BTN_FERMER' | translate"
				type="button"
				styleClass="p-button-link"
				(click)="fermerModal()"/>
	</p-footer>
</p-dialog>
